import React from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { PSA_CONSTANTS } from '@nile/components/src/Constants';


const EventWrapperStyles = styled.div`
  .rbc-event-label {
    display: none;
  }

  .rbc-background-event {
    height: 100%;
    background: none !important;
    background-color: transparent !important;
    opacity: 1 !important;
    border: none !important;
    padding: 0;
    overflow: ${(props) => props?.isSlaEvent && 'visible !important'};
    color: unset;

    .sla-event {
      position: relative;
      border-top: 1px solid #f7c1c1;
      .sla-svg {
        position: absolute;
        top: -25px;
      }
      z-index: 2 !important;
    }
  }

  .rbc-event {
    width: ${(props) => props?.blockEvent && '100% !important'};
    z-index: ${(props) => props?.blockEvent && '3 !important'};
    left: ${(props) => props?.blockEvent && '0 !important'};
    .rbc-addons-dnd-resize-ns-anchor {
      display: ${(props) =>
        props?.blockEvent ? 'block !important' : 'none !important'};
      opacity: ${(props) =>
        props?.blockEvent ? '1 !important' : '0 !important'};
      visibility: ${(props) =>
        props?.blockEvent ? 'visible !important' : 'hidden !important'};
    }

    padding: 0 !important;
    cursor: ${(props) => (props?.cursorNotAllowed ? 'not-allowed' : 'pointer')};
    background: ${(props) => `${props?.backgroundColor} !important`};
    border: ${(props) => `${props?.borderColor} !important`};

    border-radius: 5px !important;
    .event-component-style-wrapper {
      padding: ${(props) => (props?.isSmallEvent ? '5px' : '10px')};
      pointer-events: ${(props) => (props?.isDisabled ? 'none' : 'all')};
      opacity: ${(props) => (props?.isDisabled ? '0.5 ' : '1')};
    }
    color: unset !important;
    min-height: ${(props) =>
      props?.isSyncFailed ? '40px !important' : '25px !important'};
    .appointment-event {
      height: 100%;

      position: relative;
      .event-source {
        position: absolute;
        bottom: 0;
      }

      .recurring-icon {
        position: absolute;
        bottom: 0;
        right: 0;
      }

      .sync-error-container {
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .sync-loader {
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }

    .appointment-users {
      display: flex;
      gap: 5px;
    }
  }
`;

const EventWrapper = (props) => {
  const isSlaEvent = props?.event?.eventType === 'SLA_EVENT';
  const isNewEvent = props?.event?.eventType === 'NEW_EVENT';

  const start = props?.event?.start;
  const end = props?.event?.end;
  const timespent = dayjs(end).diff(dayjs(start), 'hour');

  const isSmallEvent = timespent < 1; // Time less than 15 mins
  const isDeletionInProgress =
    props?.event?.appointment?.syncStatus === 'DELETION_IN_PROGRESS';
  const isSyncFailed = props?.event?.appointment?.syncStatus === 'FAILURE';

  const getBackgroundColor = () => {
    if (isSyncFailed) {
      return 'var(--sops-scheduling-event-sync-failed-background)';
    } else if (isNewEvent) {
      return 'var(--sops-scheduling-new-event-background)';
    } else if (props?.event?.eventType === 'BLOCK_EVENT') {
      return 'rgba(230, 230, 230, 0.70)';
    } else if (
      props.event?.appointment?.sensitivity ===
      PSA_CONSTANTS.SCHEDULING_APPOINTMENT_TYPE.PRIVATE
    ) {
      return 'var(--sops-scheduling-private-event)';
    } else {
      return 'var(--sops-scheduling-event-background)';
    }
  };

  const getBorderColor = () => {
    if (isSyncFailed) {
      return '1px solid var(--sops-scheduling-event-sync-failed-border)';
    } else if (isNewEvent) {
      return '1px dashed var(--sops-scheduling-new-event-border)';
    } else if (props?.event?.eventType === 'BLOCK_EVENT') {
      return '1px solid rgba(230, 230, 230, 0.70)';
    } else if (
      props.event?.appointment?.sensitivity ===
      PSA_CONSTANTS.SCHEDULING_APPOINTMENT_TYPE.PRIVATE
    ) {
      return '1px solid var(--sops-scheduling-private-event)';
    } else {
      return '1px solid var(--sops-scheduling-event-border)';
    }
  };

  const backgroundColor = getBackgroundColor();
  const borderColor = getBorderColor();

  return (
    <EventWrapperStyles
      id="event-wrapper"
      isSlaEvent={isSlaEvent}
      isSmallEvent={isSmallEvent}
      isNewEvent={isNewEvent}
      cursorNotAllowed={isDeletionInProgress}
      isDisabled={isDeletionInProgress}
      isSyncFailed={isSyncFailed}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      blockEvent={props?.event?.eventType === 'BLOCK_EVENT'}
      className={
        props?.event?.eventType === 'BLOCK_EVENT'
          ? 'block-event'
          : 'normal-events'
      }
    >
      {props?.children}
    </EventWrapperStyles>
  );
};

export default EventWrapper;
